export type WebLinkConfig = {
  authUrl?: string;
  authToken?: string;
  agentId?: string;
  avatarSize?: 'small' | 'full';
  baseUrl?: string;
  typeLink?: 'widget' | 'page';
  variantLink?: 'default' | 'iframe' | 'image';
  companyName?: string;
  agentName?: string;
  agentImage?: string;
  title?: string;
  iframeUrl?: string;
  desktopWebsiteImageUrl?: string;
  mobileWebsiteImageUrl?: string;
  sampleQuestions?: string[];
  demoDescription?: string;
};

export const LEVKIT_BASE_URL =
  'https://dev-api.nextlevel.ai/livekit/v1/live-kit/get-token';
export const AUTHORIZATION_TOKEN =
  'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9VyX2lkIjoxLC';
export const BASE_PAGE_GEN_LINK = 'https://dev.nextlevel.ai';
export const pageBaseUrl = process.env.REACT_APP_BASE_PAGE_GEN_LINK;
export const widgetDemoUrl = process.env.REACT_APP_BASE_WIDGET_DEMO_GEN_LINK;
export const widgetIframeUrl =
  process.env.REACT_APP_BASE_WIDGET_IFRAME_GEN_LINK;
export const widgetImageUrl = process.env.REACT_APP_BASE_WIDGET_IMAGE_GEN_LINK;

export const allowedKeys: (keyof WebLinkConfig)[] = [
  'authUrl',
  'authToken',
  'agentId',
  'companyName',
  'title',
  'iframeUrl',
  'desktopWebsiteImageUrl',
  'mobileWebsiteImageUrl',
  'sampleQuestions',
  'demoDescription',
];
